import { API_CALL_STATES } from '../constants';

export default function createActionTypes(actionType) {
    return {
        NAME: actionType,
        REQUEST: `${actionType}_${API_CALL_STATES.REQUEST}`,
        SUCCESS: `${actionType}_${API_CALL_STATES.SUCCESS}`,
        ERROR: `${actionType}_${API_CALL_STATES.ERROR}`
    };
}